import { useMutation } from '@apollo/client'
import { GraphQlEnum } from '../utils/Enums'

const useMutate = (props) => {
	const { segment, action } = props
	const mutation = GraphQlEnum[segment]?.[action]?.function
	const mutationInputFunction = GraphQlEnum[segment]?.[action]?.functionInput
	const mutationInputFunction2 = GraphQlEnum[segment]?.[action]?.functionInput2
	const mutationOutputFunction = GraphQlEnum[segment]?.[action]?.functionOutput
	const [mutateFunction, { loading }] = useMutation(mutation)

	return { mutateFunction, mutationInputFunction, mutationOutputFunction, mutationInputFunction2, loading }
}

export default useMutate
